import * as angular from 'angular';
import { find } from 'lodash-es';
import * as uiGrid from 'ui-grid';
import { User } from '../../api/users.service';

class ProductCrossesGridController {
  static bindings = {
    applicationPermissions: '<',
    account: '<',
    productCrosses: '<',
    productId: '<',
    fromProduct: '<',
    productCategory: '<',
    productCrossDisputeCount: '=',
    productCrossApproveCount: '=',
    featureList: '<',
    voteOnClick: '&',
    addNoteOnClick: '&',
    searchTerm: '=',
    addCross: '&',
    crossReferenceOpinionOptions: '<'
  };

  gridApi;
  doAnimate: boolean = false;
  featureList;
  account: User;
  productCategory;
  addCross;
  productId;
  fromProduct;
  applicationPermissions;
  hasChangeCrossReferenceOpinion;

  gridConfig = {
    minRowsToShow: 4,
    enableColumnMenus: false,
    enableHorizontalScrollbar: this.uiGridConstants.scrollbars.NEVER,
    enableSorting: false,
    rowHeight: 80,
    columnDefs: [
      {
        headerCellTemplate: this.headerCellTemplate,
        displayName: 'Cross',
        cellTemplate: `<div class="ui-grid-cell-contents">
                        <div class="cross-name">
                          <i ng-if="row.entity.status === 'Discontinued'" class="apt-discontinued-icon"></i>
                          <a ng-href="/aptitude/static/products.html#/view/productID/{{row.entity.id}}" alt="product id" data-test-selector="product-cross-catalog-number">
                              <ellipsis content="row.entity.catalogNumber | aptHighlightText:grid.appScope.$ctrl.searchTerm"></ellipsis>
                          </a>
                        </div>
                        <div style="max-height: 40px; overflow-y: hidden;"
                             multiline-ellipsis="row.entity.description | aptHighlightText:grid.appScope.$ctrl.searchTerm"
                             data-test-selector="cross-description">
                        </div>
                       </div>`,
        field: 'catalogNumber',
        width: '*',
        type: 'string'
      },
      {
        headerCellTemplate: this.headerCellTemplate,
        displayName: 'Seller',
        cellTemplate: `<div class="ui-grid-cell-contents">
                            <ellipsis content="row.entity.sysSeller.name"
                                  data-test-selector="cross-seller-name">
                            </ellipsis>
                            <span ng-if="row.entity.sysSeller.name !== row.entity.manufacturer.name" class="text-muted">
                              <ellipsis content="row.entity.manufacturer.name"
                                    data-test-selector="cross-manufacturer-name">
                              </ellipsis>
                            </span>
                       </div>`,
        field: 'sysSeller.name',
        width: '*',
        type: 'string'
      },
      {
        displayName: 'Type',
        field: 'crossTypeDesc',
        cellTemplate: `<div class="ui-grid-cell-contents">
                            <!-- Cross status - e.g. "not crossed", "crossed" -->
                            <ellipsis ng-class="{'apt-yellow' : row.grid.appScope.$ctrl.crossTypeDesc(row.entity.crossTypeDesc, row.grid.appScope.$ctrl.productCategory, row.entity.category.name) === 'Not Crossed',
                                      'apt-orange' : row.grid.appScope.$ctrl.crossTypeDesc(row.entity.crossTypeDesc, row.grid.appScope.$ctrl.productCategory, row.entity.category.name) === 'Cross Not Allowed'}"
                                      content="row.grid.appScope.$ctrl.crossTypeDesc(row.entity.crossTypeDesc, row.grid.appScope.$ctrl.productCategory, row.entity.category.name)"
                                      data-test-selector="cross-type-desc">
                            </ellipsis>
                            <!-- Seller name -->
                            <ellipsis content="row.grid.appScope.$ctrl.createdBy(row.entity.crossCreatedByOrg.name, row.entity.sysSeller.name)"
                                      data-test-selector="cross-type-desc-org-name">
                            </ellipsis>
                       </div>`,
        width: '*'
      },
      {
        displayName: 'Clinical Assessment',
        headerCellClass: 'text-center',
        field: 'crossCreatedByOrg.id',
        cellTemplate: `<div class="ui-grid-cell-contents">
                            <assessment user-org-id="row.grid.appScope.$ctrl.account.organization.id"
                                        feature-list="row.grid.appScope.$ctrl.featureList"
                                        cross-reference-opinion-options="row.grid.appScope.$ctrl.crossReferenceOpinionOptions"
                                        ng-if="(row.grid.appScope.$ctrl.hasChangeCrossReferenceOpinion) && (row.entity.isCrossed === undefined || row.entity.isCrossed === true)"
                                        assessment-data="row.entity"
                                        notes-title="Assessment comments"
                                        popover-container=".apt-product-crosses-grid .ui-grid-viewport"
                                        product-id="row.grid.appScope.$ctrl.productId"
                                        product-cross-dispute-count="row.grid.appScope.$ctrl.productCrossDisputeCount"
                                        product-cross-approve-count="row.grid.appScope.$ctrl.productCrossApproveCount"
                                        vote-on-click="row.grid.appScope.$ctrl.voteOnClick({productId, crossReferenceId, opinionType, vote, toProductId, opinionOption, fromDropdown})"
                                        add-note-on-click="row.grid.appScope.$ctrl.addNoteOnClick({productId, crossReferenceId, note})">
                            </assessment>
                            <apt-assessment-lite ng-if="(!row.grid.appScope.$ctrl.hasChangeCrossReferenceOpinion) && (row.entity.isCrossed === undefined || row.entity.isCrossed === true)"
                                        assessment-data="row.entity"
                                        feature-list="row.grid.appScope.$ctrl.featureList"
                                        notes-title="Assessment comments"
                                        popover-container=".apt-product-crosses-grid .ui-grid-viewport"
                                        product-id="row.grid.appScope.$ctrl.productId"
                                        product-cross-dispute-count="row.grid.appScope.$ctrl.productCrossDisputeCount"
                                        product-cross-approve-count="row.grid.appScope.$ctrl.productCrossApproveCount"
                                        add-note-on-click="row.grid.appScope.$ctrl.addNoteOnClick({productId, crossReferenceId, note, toProductId})">
                            </apt-assessment-lite>
                            <button ng-if="row.grid.appScope.$ctrl.showAddCrossButton(row.entity)"
                                    data-test-selector="add-cross-button"
                                    class="btn btn-default add-button"
                                    ng-click="row.grid.appScope.$ctrl.addCrossOnClick(row.grid.appScope.$ctrl.fromProduct, row.entity)">Add Cross
                            </button>
                       </div>`,
        width: '*'
      }
    ],
    // The filtered products
    data: [],
    onRegisterApi: (gridApi) => {
      this.gridApi = gridApi;
    }
  };

  constructor(
    private uiGridConstants,
    private GridScrollHistory,
    private $scope,
    private $animate,
    private $element,
    private headerCellTemplate,
    private $filter
  ) {
    'ngInject';
  }

  $onInit() {
    this.hasChangeCrossReferenceOpinion = this.findApplicationPermission(
      this.applicationPermissions,
      'CHANGE_CROSS_REFERENCE_OPINION'
    );
  }

  $onChanges(changes) {
    // this.animateGridOnEntry();

    if (changes.productCrosses && changes.productCrosses.currentValue) {
      this.gridConfig.data = changes.productCrosses.currentValue.crosses || [];
      this.$animate.addClass(this.$element[0].firstChild, 'fadeIn');

      this.$scope.$watch('$ctrl.productCrosses', (newValue, oldValue) => {
        this.gridConfig.data = newValue || [];
        this.$animate.addClass(this.$element[0].firstChild, 'fadeIn');
      });
    }
  }

  findApplicationPermission = this.$filter('findApplicationPermission');

  crossTypeDesc(
    crossTypeDesc,
    modalProductCategory,
    searchResultProductCategory
  ) {
    if (crossTypeDesc) {
      return crossTypeDesc;
    } else {
      return 'Not Crossed';
    }
  }

  createdBy(createdBy, sysSeller) {
    if (createdBy !== sysSeller) {
      return createdBy;
    }
  }

  addCrossOnClick(fromProduct, toProduct) {
    this.addCross({ fromProduct: fromProduct, toProduct: toProduct });
    toProduct.isCrossed = true;
  }

  showAddCrossButton(rowEntity) {
    return !rowEntity.isCrossed && !rowEntity.crossTypeDesc;
  }

  isProductInSameCategory(categoryName): boolean {
    // console.log(categoryName, this.productCategory);
    return this.productCategory === categoryName;
  }
}

export const ProductCrossesGridComponent = {
  bindings: ProductCrossesGridController.bindings,
  controller: ProductCrossesGridController,
  template: `<div class="apt-ui-grid-default grid-with-cell-borders apt-product-crosses-grid"
               ui-grid="$ctrl.gridConfig"
               ui-grid-auto-resize
               ui-grid-resize-columns
               ui-grid-save-state
               data-test-selector="product-crosses-grid"></div>
            `
};
